<div class="container-fluid" id="attachmentDialog-container">
  <div class="row" id="attachmentDialog-container-row">
    <div id="attachmentDialog-container-div" class="col-11 nopadLR GreyDarkest h3Header">ADD ATTACHMENT</div>
    <div id="attachmentDialog-container-div2" class="col-1 nopadR" style="cursor: pointer">
      <img
        id="attachmentDialog-container-img"
        src="assets/images/icons/default_icons/icon-close.png"
        alt="close"
        (click)="closeDialog()"
        (keyup.enter)="closeDialog()"
        tabindex="0"
      />
    </div>
  </div>

  <div
    id="attachmentDialog-container-div3"
    appDrag
    (onFileDropped)="uploadFile($event)"
    class="row marTB24 dragDropBox"
  >
    <div id="attachmentDialog-container-div4" style="text-align: center; margin: 0 auto; display: flex" class="row">
      <div class="col-12 inB" id="attachmentDialog-container-div-5">
        <img
          id="attachmentDialog-container-img2"
          src="assets/images/icons/default_icons/icon-upload.png"
          alt="upload"
        />

        <input
          id="attachmentDialog-container-input"
          [attr.multiple]="uploadType === 'multipleSelect' ? 'multiple' : null"
          hidden
          accept="allowedFileTypes"
          type="file"
          (change)="onFileSelected($event)"
          #file
        />
        <span id="attachmentDialog-container-span" class="h4Header GreyDarkest">Drag and Drop or </span>
        <span
          id="attachmentDialog-container-span2"
          class="clearFix Me-PrimaryDark h4Header"
          style="cursor: pointer"
          (click)="file.click()"
          (keyup.enter)="file.click()"
          tabindex="0"
          >Browse file(s)</span
        >
        <br id="attachmentDialog-container-br" />
      </div>
      <div
        id="attachmentDialog-container-div6"
        class="col-12 GreyLight mainBodyTxt4 nopadT inB relative"
        style="line-height: 30px; margin-top: 10px"
      >
        Allowed file types: {{ allowedFileTypes }}
      </div>
    </div>
    <label id="attachmentDialog-container-label" class="file_error">{{ fileSizeError }}</label>
  </div>
  <div class="row" id="attachmentDialog-container-div7">
    <mat-chip-listbox id="attachmentDialog-container-matChipList">
      @for (file of filename; track file) {
        <mat-chip-option class="DSA_wb_chipStyle-Normal active marR16" id="attachmentDialog-container-matCHIP">
          <a
            id="attachmentDialog-container-a2"
            href="javascript:void();"
            class="icon x-16 icon-close-mini chipIconRight"
            aria-label="Remove file"
            (click)="removeParent(file)"
            (keyup.enter)="removeParent(file)"
            tabindex="0"
          ></a>
          {{ file }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>

  <div class="row marT8" id="attachmentDialog-container-div8">
    <button id="attachmentDialog-container-button" mat-flat-button class="text-btn" [mat-dialog-close]="fileArray">
      OK
    </button>
    <button id="attachmentDialog-container-button2" mat-flat-button class="text-btn" [mat-dialog-close]="">
      CANCEL
    </button>
  </div>
</div>
